import React from 'react';
import ImportWizardPage from './ImportWizardPage';
import MapWorkOrderMandatoryFieldsStep from '../components/workOrder/MapWorkOrderMandatoryFieldsStep';
import MapWorkOrderAdditionalFieldsStep from '../components/workOrder/MapWorkOrderAdditionalFieldsStep';
import WorkOrderPreviewStep from '../components/workOrder/PreviewStep';
import WorkOrderSubmitModal from '../components/workOrder/SubmitModal';
import WorkOrderSuccessModal from '../components/workOrder/SuccessModal';

const initialTargetDropdownSelections: Record<string, string> = {
  asset_identifier: 'asset_tag',
};

const NewDataWorkOrderImportPage: React.FC = () => (
  <ImportWizardPage
    title="New Data Work Order Import"
    entityLabelPlural="work orders"
    listPath="/work-orders/list"
    initialTargetDropdownSelections={initialTargetDropdownSelections}
    uniqueFieldKey="asset_identifier"
    MapMandatoryFieldsStep={MapWorkOrderMandatoryFieldsStep}
    MapAdditionalFieldsStep={MapWorkOrderAdditionalFieldsStep}
    PreviewStep={WorkOrderPreviewStep}
    SubmitModal={WorkOrderSubmitModal}
    SuccessModal={WorkOrderSuccessModal}
  />
);

export default React.memo(NewDataWorkOrderImportPage);
